'use strict';

angular.module('atex.art', ['ngRoute', 'ngTouch', 'ui.directives', 'atex.onecms.service',
  'atex.onecms.application', 'atex.onecms.authentication', 'atex.onecms.ui', 'atex.onecms.ui.widgets',
  'atex.art.content', 'valdr', 'pascalprecht.translate', 'emguo.poller', 'ui.select', 'xeditable','ngSanitize',
  function ($provide) {
    $provide.decorator('Application', ['$delegate', function ($delegate) {
      /**
       * This is a chance to inject application wide settings.
       */
      $delegate.settings.prefix = 'act';
      return $delegate;
    }]);

    $provide.decorator('$q', ['$delegate', function ($delegate) {
      $delegate.allSettled = atex.onecms.AngularUtils.allSettled.bind($delegate, $delegate);

      return $delegate;
    }]);
  }
]);
